var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 210.1 210.1",
    viewBox: "0 0 210.1 210.1",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    fill: "#ffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.859 0H24.242C10.874 0 0 10.874 0 24.242v161.616C0 199.226 10.874 210.1 24.242 210.1h161.616c13.368 0 24.242-10.874 24.242-24.242V24.242C210.101 10.874 199.227 0 185.859 0zm16.161 185.859c0 8.912-7.248 16.162-16.162 16.162H24.242c-8.914 0-16.162-7.25-16.162-16.162V24.242c0-8.912 7.248-16.162 16.162-16.162h161.616c8.914 0 16.162 7.25 16.162 16.162v161.617z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.293 80.808H80.808V32.323H32.323v145.455h48.485v-48.485h48.485v48.485h48.485V32.323h-48.485v48.485zm8.08-40.404h32.324v129.293h-32.323v-48.485H72.727v48.485H40.404V40.404h32.323v48.485h64.646V40.404z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.3840d778bfdd6963be681ef977467332.svg";
export { ForwardRef as ReactComponent };